function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
}

function accountLabel(user, accountType) {
  if (user.displayName) return user.displayName;
  if (accountType === 'student' && user.email) return user.email.split('@')[0].toUpperCase();
  return user.email || user.uid;
}

function roleLabel(role) {
  return role === 'teacher' ? 'Giáo viên' : role === 'parent' ? 'Phụ huynh' : role === 'student' ? 'Học sinh' : 'Tài khoản';
}

function showAccountInformation(user, accountType, creatorState) {
  const previousFocus = document.querySelector('.user-menu-trigger') || document.activeElement;
  const role = accountType === 'student' ? 'student' : creatorState?.activeRole || 'teacher';
  const backdrop = document.createElement('div');
  backdrop.className = 'account-dialog-backdrop';
  backdrop.innerHTML = `<section class="account-dialog" role="dialog" aria-modal="true" aria-labelledby="accountDialogTitle">
    <div class="account-dialog-header"><h2 id="accountDialogTitle">Thông tin tài khoản</h2><button class="secondary icon-button" type="button" data-close-account aria-label="Đóng">×</button></div>
    <dl class="account-details">
      <div><dt>Tên hiển thị</dt><dd>${escapeHtml(accountLabel(user, accountType))}</dd></div>
      <div><dt>Tài khoản</dt><dd>${escapeHtml(user.email || user.uid)}</dd></div>
      <div><dt>Vai trò hiện tại</dt><dd>${escapeHtml(roleLabel(role))}</dd></div>
    </dl>
  </section>`;
  const close = () => { document.removeEventListener('keydown', onKeyDown); backdrop.remove(); if (previousFocus?.isConnected) previousFocus.focus(); };
  const onKeyDown = event => {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab') { event.preventDefault(); backdrop.querySelector('[data-close-account]').focus(); }
  };
  backdrop.addEventListener('click', event => { if (event.target === backdrop) close(); });
  backdrop.querySelector('[data-close-account]').addEventListener('click', close);
  document.addEventListener('keydown', onKeyDown);
  document.body.appendChild(backdrop);
  backdrop.querySelector('[data-close-account]').focus();
}

export function renderUserMenu(container, { user, accountType, creatorState, onAddRole, onChangePin, onStudentSettings, onSwitchRole, onLogout }) {
  container._userMenuAbortController?.abort();
  const controller = new AbortController();
  container._userMenuAbortController = controller;
  if (!user) return void container.replaceChildren();
  const label = accountLabel(user, accountType);
  const roles = accountType === 'creator' ? creatorState?.roles || [] : [];
  const activeRole = creatorState?.activeRole;
  container.innerHTML = `<div class="user-menu">
    <button class="user-menu-trigger" type="button" aria-haspopup="menu" aria-expanded="false">
      <span class="user-avatar" aria-hidden="true">${escapeHtml(label.slice(0, 1).toUpperCase())}</span>
      <span class="user-menu-identity"><strong>${escapeHtml(label)}</strong><small>${escapeHtml(roleLabel(accountType === 'student' ? 'student' : activeRole))}</small></span>
      <span class="user-menu-caret" aria-hidden="true">▾</span>
    </button>
    <div class="user-menu-dropdown" role="menu" hidden>
      <button type="button" role="menuitem" data-account-info>Thông tin tài khoản</button>
      ${roles.length > 1 ? roles.filter(role => role !== activeRole).map(role => `<button type="button" role="menuitem" data-switch-role="${role}">Chuyển sang ${roleLabel(role)}</button>`).join('') : ''}
      ${accountType === 'creator' && roles.length === 1 ? `<button type="button" role="menuitem" data-add-role>Thêm vai trò ${roleLabel(roles[0] === 'teacher' ? 'parent' : 'teacher')}</button>` : ''}
      ${accountType === 'student' ? '<button type="button" role="menuitem" data-change-pin><svg class="action-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:middle;pointer-events:none;flex-shrink:0"><path d="M8 15a5 5 0 1 1 4-8l9 0v4h-3v3h-4l-2-2"/></svg> Đổi PIN</button><button type="button" role="menuitem" data-student-settings><svg class="action-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:middle;pointer-events:none;flex-shrink:0"><path d="M4 6h16M4 12h16M4 18h16M8 3v6M16 9v6M10 15v6"/></svg> Cài đặt</button>' : ''}
      <div class="user-menu-separator" role="separator"></div>
      <button type="button" role="menuitem" data-logout><svg class="action-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" style="vertical-align:middle;pointer-events:none;flex-shrink:0"><path d="M10 3H4v18h6M9 12h12m-5-5 5 5-5 5"/></svg> Đăng xuất</button>
    </div>
  </div>`;
  const menu = container.querySelector('.user-menu');
  const trigger = menu.querySelector('.user-menu-trigger');
  const dropdown = menu.querySelector('.user-menu-dropdown');
  const close = () => { dropdown.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
  const toggle = () => {
    dropdown.hidden = !dropdown.hidden;
    trigger.setAttribute('aria-expanded', String(!dropdown.hidden));
    if (!dropdown.hidden) dropdown.querySelector('[role="menuitem"]')?.focus();
  };
  trigger.addEventListener('click', toggle);
  menu.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); trigger.focus(); } });
  menu.addEventListener('keydown', event => {
    if (dropdown.hidden || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const items = [...dropdown.querySelectorAll('[role=menuitem]')];
    let index = items.indexOf(document.activeElement);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items[index].focus();
  });
  document.addEventListener('click', event => { if (!menu.contains(event.target)) close(); }, { capture: true, signal: controller.signal });
  menu.querySelector('[data-account-info]').addEventListener('click', () => { close(); showAccountInformation(user, accountType, creatorState); });
  menu.querySelector('[data-change-pin]')?.addEventListener('click', async () => { close(); await onChangePin?.(); });
  menu.querySelector('[data-student-settings]')?.addEventListener('click', () => { close(); trigger.focus(); onStudentSettings?.(); });
  menu.querySelector('[data-add-role]')?.addEventListener('click', async () => { close(); await onAddRole?.(); });
  menu.querySelectorAll('[data-switch-role]').forEach(button => button.addEventListener('click', async () => { close(); await onSwitchRole?.(button.dataset.switchRole); }));
  menu.querySelector('[data-logout]').addEventListener('click', () => { close(); onLogout(); });
}
